import React from 'react';
import EventEmitter from 'events';

import UserStore from './user_store';

import util from '../tools/util';

export default {
  init,
  useList,
  useInvoice,
  fetch,
  fetchInvoice,
};

const g_orgListMap = new Map<number, any[]>();
const g_invoiceMap = new Map<string, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function _getList(org_id: number) {
  return g_orgListMap.get(org_id);
}
function _getInvoice(invoice_id: string) {
  return g_invoiceMap.get(invoice_id);
}
export function useList(org_id: number) {
  const _get = React.useCallback(() => _getList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function useInvoice(invoice_id: string) {
  const _get = React.useCallback(() => _getInvoice(invoice_id), [invoice_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function init(done?: (err?: any) => void) {
  done?.();
}
function fetch(org_id: number, done?: (err?: any) => void) {
  const opts = {
    url: `/api/1/org/${org_id}/invoice`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('invoice_store.fetch: err:', err);
    } else if (body) {
      const old = g_orgListMap.get(org_id);
      if (!util.deepEqual(old, body.invoice_list)) {
        g_orgListMap.set(org_id, body.invoice_list);
        _emit('list');
      }
    }
    done?.(err);
  });
}
function fetchInvoice(params, done?: (err?: any) => void) {
  const opts = {
    url: `/api/1/org/${params.org_id}/invoice/${params.invoice_id}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('invoice_store.fetch: err:', err);
    } else if (body) {
      const old = g_invoiceMap.get(params.invoice_id);
      if (!util.deepEqual(old, body)) {
        g_invoiceMap.set(params.invoice_id, body);
        _emit('invoice');
      }
    }
    done?.(err);
  });
}
